export const PROJECTS = [
  {
    slug: "tiger-holding-room-thyavarekoppa",
    workId: "tiger-holding-room-thyavarekoppa",
    category: "Wildlife facilities",
    title: "Tiger holding room and paddock, Tiger and Lion Safari, Thyavarekoppa",
    short: "Tiger holding rooms, Thyavarekoppa",
    location: "Thyavarekoppa, Shivamogga, Karnataka",
    client: "Karnataka Forest Department",
    division: "Wildlife Division, Shivamogga (CAMPA)",
    year: "2023–24",
    completed: "20 Mar 2024",
    value: "₹99.95 L",
    valueNote: "Estimated cost",
    tendered: "Tendered ₹86.87 L incl. GST",
    summary: "Five tiger holding rooms with a 1,200 sqm welded steel paddock for the Tiger and Lion Safari at Thyavarekoppa. The job covered earthwork, PCC and RCC, stone and brick masonry, built-up steel sections, GI chain link fabric, roofing sheets, plastering and painting.",
    highlights: ["5 holding rooms", "1,200 sqm paddock", "25.5 t welded steel", "1,349 sqm chain link"],
    items: [
      ["Earth work excavation", "321.78", "cum"], ["PCC & RCC work", "170.00", "cum"], ["Size stone masonry", "122.63", "cum"],
      ["Brick work masonry", "45.15", "sqm"], ["Earth filling", "321.78", "cum"], ["TMT steel work", "5,197.86", "kg"],
      ["Steel work welded in built-up sections / framed work", "25,499.61", "kg"], ["GI chain link fabric fencing", "1,349.48", "sqm"],
      ["Pre-coated GI profile sheets", "63.75", "sqm"], ["Plastering work", "538.04", "sqm"], ["Painting work", "2,564.21", "sqm"],
    ],
    images: [
      { src: "/img/tiger-block.jpg", alt: "Tiger holding room block in brick with red roof band" },
      { src: "/img/tiger-paddock.jpg", alt: "Tiger holding room with steel paddock enclosure" },
      { src: "/img/hero.jpg", alt: "Completed holding room and steel paddock enclosure" },
      { src: "/img/stone-roof.jpg", alt: "Stone clad service building with roof finishing in progress" },
      { src: "/img/stone-block.jpg", alt: "Stone clad holding room with paddock in front" },
      { src: "/img/tiger-2.jpg", alt: "Tiger holding room with steel paddock frame" },
      { src: "/img/tiger-3.jpg", alt: "Tiger holding room during finishing works, with crew on site" },
      { src: "/img/tiger-4.jpg", alt: "Welded steel paddock enclosure beside the tiger holding room" },
      { src: "/img/tiger-5.jpg", alt: "Tiger holding room entrance during painting" },
      { src: "/img/stone-2.jpg", alt: "Stone clad service building at the safari" },
    ],
  },
  {
    slug: "leopard-holding-room-rescue-centre",
    workId: "leopard-holding-room-thyavarekoppa",
    category: "Wildlife facilities",
    title: "Leopard holding room and paddock, Tiger / Leopard / Panther Rescue Centre, Thyavarekoppa",
    short: "Leopard rescue centre, Thyavarekoppa",
    location: "Thyavarekoppa, Shivamogga, Karnataka",
    client: "Karnataka Forest Department",
    division: "Wildlife Division, Shivamogga (CAMPA)",
    year: "2023–24",
    completed: "20 Mar 2024",
    value: "₹95.00 L",
    valueNote: "Estimated cost",
    tendered: "Tendered ₹88.03 L incl. GST",
    summary: "Part 2 of the Tiger / Leopard / Panther Rescue Centre: five leopard holding rooms with steel cages and a 1,000 sqm paddock area, built alongside the safari's existing facilities.",
    highlights: ["5 holding rooms", "1,000 sqm paddock", "23.8 t welded steel", "1,247 sqm chain link"],
    items: [
      ["Earth work excavation", "260.84", "cum"], ["PCC & RCC work", "161.74", "cum"], ["Size stone masonry", "118.06", "cum"],
      ["Brick work masonry", "47.00", "sqm"], ["Earth filling", "260.84", "cum"], ["TMT steel work", "4,900.00", "kg"],
      ["Steel work welded in built-up sections / framed work", "23,798.55", "kg"], ["GI chain link fabric fencing", "1,246.85", "sqm"],
      ["Pre-coated GI profile sheets", "85.00", "sqm"], ["Plastering work", "549.91", "sqm"], ["Painting work", "2,383.82", "sqm"],
    ],
    images: [
      { src: "/img/leopard-block.jpg", alt: "Leopard holding room block with paddocks" },
      { src: "/img/leopard-cages.jpg", alt: "Row of steel holding cages inside the leopard block" },
      { src: "/img/leopard-enclosure.jpg", alt: "Steel paddock enclosure among trees" },
      { src: "/img/cage-interior.jpg", alt: "Holding cage interior with sliding steel gate" },
      { src: "/img/leopard-paddock.jpg", alt: "Paddocks and service building in the rescue centre" },
      { src: "/img/leopard-6.jpg", alt: "Leopard holding room block with covered paddock" },
      { src: "/img/leopard-2.jpg", alt: "Leopard rescue centre with paddocks behind" },
      { src: "/img/leopard-3.jpg", alt: "Paddock enclosures at the rescue centre" },
      { src: "/img/leopard-4.jpg", alt: "Chain link paddock enclosure among trees" },
      { src: "/img/leopard-5.jpg", alt: "Steel feeding cage inside a paddock" },
      { src: "/img/leopard-7.jpg", alt: "Paddock mesh with holding room behind" },
      { src: "/img/leopard-8.jpg", alt: "Holding room corridor with steel cage gates" },
      { src: "/img/leopard-9.jpg", alt: "Row of holding cages with sliding gates" },
    ],
  },
  {
    slug: "ajjampura-tunnel-trash-gate",
    workId: "ajjampura-tunnel-trash-gate",
    category: "Irrigation",
    title: "Vertical lift trash gate at the 7 km Ajjampura tunnel, Upper Bhadra Project",
    short: "Ajjampura tunnel gate",
    location: "Ajjampura, Chikkamagaluru, Karnataka",
    client: "Visvesvaraya Jala Nigam Limited",
    division: "UBP Division No. 3, Ajjampura",
    year: "2025–26",
    completed: "2025–26",
    value: "₹25.18 L",
    valueNote: "Incl. GST",
    summary: "Fabrication and installation of a 3.5 m × 4.5 m vertical lift trash gate with 25 mm MS square mesh at the approach to the 7 km Ajjampura tunnel, including embedded parts, the lift gate and a screw hoist.",
    highlights: ["3.5 m × 4.5 m gate", "25 mm MS square mesh", "Screw hoist", "1,274 anchor rods"],
    items: [["Vertical lift trash gate", "3.5 × 4.5", "m"], ["MS square mesh", "25", "mm"], ["Anchor rods", "1,274", "nos"], ["Embedded parts, lift gate and screw hoist", "1", "set"]],
    images: [
      { src: "/img/gate-1.jpg", alt: "Vertical lift trash gate frame at the tunnel approach" },
      { src: "/img/gate-2.jpg", alt: "Tunnel mouth with steel mesh gate installed" },
    ],
  },
  {
    slug: "shivamogga-elephant-proof-trench",
    workId: "shivamogga-elephant-proof-trench",
    category: "Trenches & barricades",
    title: "Elephant proof trench in Shimoga, Sacrebyle and Mugudthi ranges",
    short: "Elephant proof trench, Shivamogga",
    location: "Shimoga, Sacrebyle and Mugudthi ranges, Karnataka",
    client: "Karnataka Forest Department",
    division: "Wildlife Division, Shivamogga (CAMPA)",
    year: "2022–23",
    completed: "2022–23",
    value: "₹98.00 L",
    valueNote: "Amount paid",
    summary: "9.3 km of elephant proof trench excavated across three forest ranges to reduce human–elephant conflict and keep herds away from farms and settlements.",
    highlights: ["9.3 km trench", "62,762 cum excavated", "3 forest ranges"],
    items: [["Elephant proof trench length", "9.3", "km"], ["Excavation", "62,762", "cum"]],
    images: [{ src: "/img/ept-trench.jpg", alt: "Freshly excavated trench alongside a steel enclosure" }],
  },
  {
    slug: "chitradurga-chain-link-fencing",
    workId: "chitradurga-chain-link-fencing",
    category: "Fencing",
    title: "Chain link mesh fencing at Nayakanahatti hobli, Challakere range (3 packages)",
    short: "Chain link fencing, Chitradurga",
    location: "Kaval Sy. No. 343, Nayakanahatti hobli, Challakere, Chitradurga, Karnataka",
    client: "Karnataka Forest Department",
    division: "Chitradurga Division (CAMPA)",
    year: "2022–23",
    completed: "2022–23",
    value: "₹236.59 L",
    valueNote: "3 packages",
    summary: "Three packages of GI chain link mesh fencing on angle iron posts with concrete footings, totalling 7.8 km around forest land in the Challakere range. Photos below are from our chain link fencing sites.",
    highlights: ["3 × 2.601 km", "7.8 km total", "GI chain link on angle iron posts"],
    items: [["Package 1 fencing", "2.601", "km"], ["Package 2 fencing", "2.601", "km"], ["Package 3 fencing", "2.601", "km"], ["Total length", "7.8", "km"]],
    images: [
      { src: "/img/fence-hills.jpg", alt: "Chain link fence running across hilly scrub land" },
      { src: "/img/fence-inspection.jpg", alt: "Forest officials inspecting a new chain link fence" },
      { src: "/img/fence-green.jpg", alt: "Completed green chain link fence along a forest boundary" },
      { src: "/img/fence-posts.jpg", alt: "Angle iron fence posts with barbed wire on top" },
      { src: "/img/fence-crew.jpg", alt: "Our crew along a finished chain link fence" },
      { src: "/img/fence-material.jpg", alt: "GI chain link mesh rolls stacked at site" },
    ],
  },
  {
    slug: "aldara-railway-barricade",
    workId: "aldara-railway-barricade",
    category: "Trenches & barricades",
    title: "Railway barricade from N.R. Pura main road to Kanagalasara hostel, Aldara section, Bhadra Tiger Reserve",
    short: "Railway barricade, Bhadra Tiger Reserve",
    location: "Aldara section (km 1.794 to 2.445), Lakkavalli Wildlife Range, Chikkamagaluru, Karnataka",
    client: "Karnataka Forest Department",
    division: "Bhadra Tiger Reserve, Lakkavalli Wildlife Range",
    year: "2022–23",
    completed: "2022–23 (certified 13 Jun 2024)",
    value: "₹89.78 L",
    valueNote: "Contract value",
    tendered: "Work order 06/2022-23 dated 01 Feb 2023",
    summary: "A railway barricade along the Aldara section of the Lakkavalli Wildlife Range, from the N.R. Pura main road to the Kanagalasara hostel. Executed by e-tender under the capital outlay head for railway barricades to prevent man–animal conflict, and certified on completion by the Field Director, Bhadra Tiger Reserve.",
    highlights: ["km 1.794 to 2.445", "₹89,78,329.57", "Prevents man–animal conflict"],
    items: [["Barricade chainage", "1.794 – 2.445", "km"], ["Barricade length", "0.651", "km"], ["Contract value", "89,78,329.57", "₹"], ["Work order", "06/2022-23 · 01-02-2023", "CF/CKM"]],
    images: [],
  },
  {
    slug: "anjanapura-dam-maintenance",
    workId: "anjanapura-dam-maintenance",
    category: "Irrigation",
    title: "Annual maintenance of Anjanapura Dam and gates, Anjanapura Reservoir Project, Shikaripura",
    short: "Anjanapura dam and gates",
    location: "Anjanapura, Shikaripura, Shivamogga, Karnataka",
    client: "Karnataka Neeravari Nigam Limited",
    division: "Dandavathi Reservoir Project Division",
    year: "2021–22",
    completed: "28 Feb 2022",
    value: "₹61.04 L",
    valueNote: "Work done, excl. GST",
    tendered: "₹61.15 L agreement (171/2020-21)",
    summary: "Annual maintenance of the Anjanapura Dam and gates, with repairs, under the Anjanapura Reservoir Project in Shikaripura taluk (Indent No. 31031). The work covered silt removal, concrete works, a new embedded-parts set with top seal seat, and a screw-type hoist, and was certified as satisfactory by the Executive Engineer.",
    highlights: ["14.29 t embedded parts", "16.93 t screw hoist", "13,750 sand bags", "Estimate ₹71 L"],
    items: [
      ["Silt removal from canal bed", "105.00", "cum"], ["Dismantling of existing structures", "4.88", "cum"],
      ["Excavation for canal drainage foundation", "97.43", "cum"], ["Embankment with murum", "214.50", "cum"],
      ["M-10 vibrated cement concrete", "68.59", "cum"], ["M-20 vibrated cement concrete", "143.41", "cum"],
      ["Reinforcement steel for RCC", "2,880.00", "kg"], ["Embedded parts with top seal seat", "14.29", "t"],
      ["Screw type hoist", "16.93", "t capacity"], ["Sand bags", "13,750", "nos"],
      ["150 mm hume pipe weep holes", "35.20", "rmt"], ["Rubble and sand filling behind abutments", "40.50", "cum"],
    ],
    images: [],
  },
];

export const projectForWork = (workId) => PROJECTS.find((p) => p.workId === workId);
